import React, { useEffect, useState } from "react";
import { message } from "antd";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import "./AuthenticatorQrForm.scss";

export function AuthenticatorEnableDisable(
  props: React.PropsWithChildren<any>
): JSX.Element {
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const factorAuthEnable = props.factorAuthEnable;
  console.log(`Props`, props);

  const handleCancel = () => {
    setShowConfirm(false);
    console.log(`Cancelled`);
  };

  const handleConfirm = () => {
    authSVC
      .toggle2FA({})
      .then((res: any) => {
        if (res.data.success === true) {
          message.success(res.data.message);
          console.log(`Toggle ${res}`);
          localStorage.setItem(
            "authenticatorEnable",
            res.data.two_factor_enabled
          );
          localStorage.setItem("showAuthenticatorQR", "false");
          if (factorAuthEnable == "true") {
          }
          setTimeout(() => {
            navigate(-1);
          }, 1500);
        } else {
          message.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  const toggle2FA = () => {
    setShowConfirm(true);
  };
  return (
    <>
      <button
        type="button"
        className="qr-form__setup-btn"
        onClick={toggle2FA}
      >
        <span>🔐</span>
        {factorAuthEnable == "true" ? "Disable 2FA" : "Enable 2FA"}
      </button>
      {showConfirm && (
        <div className="qr-backdrop" onClick={handleCancel}>
          <div className="qr-dialog" onClick={(e) => e.stopPropagation()}>

            <div className="qr-dialog__icon-wrap">
              <span>🔐</span>
            </div>

            <h3 className="qr-dialog__title">
              {factorAuthEnable == "true" ? "Disable 2FA?" : "Enable 2FA?"}
            </h3>
            <p className="qr-dialog__desc">
              {factorAuthEnable == "true"
                ? "Turning this off removes the extra verification step when you log in. Your account will rely on your password alone."
                : "You'll scan a QR code with your authenticator app to complete setup. This adds a strong layer of security to your account."}
            </p>

            <div className="qr-dialog__actions">
              <button
                className="qr-dialog__btn qr-dialog__btn--confirm"
                onClick={handleConfirm}
              >
                {factorAuthEnable == "true" ? "Yes, Disable" : "Yes, Enable"}
              </button>
              <button
                className="qr-dialog__btn qr-dialog__btn--cancel"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}
